import React from "react";

const ActionModal = ({ closeModal, deleteContent, onEdit }) => {
  return (
    <div className="card bg-gray pt-3">
      <button
        type="button"
        className="close close__modal position-absolute position--modalclose"
        aria-label="Close"
        onClick={() => closeModal()}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h6 className="text-fw-bold text-center mb-3_5">
        アクションを選択してください
      </h6>
      <div className="card bg-white h-100">
        <ul className="nav flex-column">
          <li
            className="nav-item p-3 border-bottom cursor-pointer"
            key={1}
            onClick={() => onEdit()}
          >
            <label className="d-flex justify-content-between align-items-center mb-0 position-relative cursor-pointer">
              <span className="p-0 line-height-2 pl-3 mb-0">編集する</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
          <li
            className="nav-item p-3 border-bottom cursor-pointer"
            key={2}
            onClick={() => deleteContent()}
          >
            <label className="d-flex justify-content-between align-items-center mb-0 position-relative cursor-pointer">
              <span className="p-0 line-height-2 pl-3 mb-0">削除する</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
          <li
            className="nav-item p-3 border-bottom cursor-pointer" 
            key={3}
            onClick={() => closeModal()}
          >
            <label className="d-flex justify-content-between align-items-center mb-0 position-relative cursor-pointer">
              <span className="p-0 line-height-2 pl-3 mb-0">キャンセル</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionModal;